import axios from 'axios';
import { refreshClientToken } from './client-api.js';
import Cookie from 'js-cookie';

const xmlimportapi = axios.create( {
    baseURL: import.meta.env.TWC_XML_IMPORT_API,
    validateStatus: function( status ) {
        return true;
    },
} );

let handleRequest = async ( request ) => {
    const token = Cookie.get( 'access_token' );

    if ( token ) {
        request.headers.Authorization = `Bearer ${token}`;
    }

    return request;
};

let handleResponse = async ( response ) => {
    const status = response.status;

    // unathorized (try to refresh token?)
    if ( status === 401 ) {
    // check if we already tried
        if ( response.config._retry ) {
            return response;
        }

        if ( await refreshClientToken() ) {
            response.config._retry = true;
            return xmlimportapi.request( response.config );
        }
    }

    return response;
};

const handleError = ( error ) => {
    return Promise.reject( error );
};

xmlimportapi.interceptors.request.use( handleRequest, handleError );
xmlimportapi.interceptors.response.use( handleResponse, handleError );

export default xmlimportapi;
